<template>
  <div>
    <vs-row>
      <vs-col :lg="6" :sm="12">
        <div class="login-container">
          <img src="@/assets/images/login.svg" />
        </div>
      </vs-col>
      <vs-col :lg="6" :sm="12">
        <div class="form-container">
          <vs-row>
            <vs-col :lg="2" :sm="0"> </vs-col>
            <vs-col :lg="8" :sm="12">
              <div class="logo_img">
                <img src="@/assets/images/logo.svg" />
              </div>

              <h3 class="com_name">Company Name</h3>
              <h1 class="wel_back">Welcome Back</h1>
              <h5 class="text">
                Enter you Email and Password to access your account
              </h5>
              <vs-input
                label="Email"
                v-model="email"
                placeholder="Enter Your Email"
              />
              <vs-input
                type="password"
                v-model="password"
                label="Password"
                placeholder="Enter Your Password"
                :progress="getProgress"
                :visiblePassword="hasVisiblePassword"
                icon-after
                @click-icon="hasVisiblePassword = !hasVisiblePassword"
              >
                <template #icon>
                  <span
                    v-if="!hasVisiblePassword"
                    class="material-symbols-outlined"
                  >
                    visibility
                  </span>

                  <span v-else class="material-symbols-outlined">
                    visibility_off
                  </span>
                </template>

                <template v-if="getProgress >= 100" #message-success>
                  Secure password
                </template>
              </vs-input>

              <div class="forget_pass">
                <vs-checkbox> Remember me </vs-checkbox>
                <h5 class="forget_pass_text">Forget Password</h5>
              </div>

              <vs-button class="w-full mt-4" @click="signIn()"
                >Sign In</vs-button
              >

              <div class="sign_google w-full mt-4">
                <img src="@/assets/images/flat-color-icons_google.svg" />Sign in
                with Google

                <!-- <a href="#" class="sign_google">Sign in with Google</a> -->
              </div>
              <h5 class="sign_up">Don't have an account? Sign Up</h5>
            </vs-col>
            <vs-col :lg="2" :sm="0"> </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
export default {
  data: () => ({
    email: "",
    hasVisiblePassword: false,
    password: "",
    active: 0,
    option: false,
  }),
  methods: {
    async signIn() {
      try {
        await this.$store.dispatch("auth/setUser", {
          username: this.email,
          password: this.password,
        });
        this.$router.push(`/`);
      } catch (e) {
        this.$toasted.error("Something went wrong!");
      }
    },
  },
  computed: {
    getProgress() {
      let progress = 0;

      // at least one number

      if (/\d/.test(this.password)) {
        progress += 20;
      }

      // at least one capital letter

      if (/(.*[A-Z].*)/.test(this.password)) {
        progress += 20;
      }

      // at menons a lowercase

      if (/(.*[a-z].*)/.test(this.password)) {
        progress += 20;
      }

      // more than 5 digits

      if (this.password.length >= 6) {
        progress += 20;
      }

      // at least one special character

      if (/[^A-Za-z0-9]/.test(this.password)) {
        progress += 20;
      }

      return progress;
    },
  },
};
</script>
<style lang="scss" scoped>
.login-container {
  background: #f4f7fe;
  width: 100%;
  height: calc(120vh - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  img {
    max-width: 90%;
  }
}
.form-container {
  padding: 50px 30px;
}
@media (max-width: 900px) {
  .login-container {
    height: calc(100vw);
    max-height: 90vh;
  }
}
.logo_img {
  text-align: center;
}
.com_name {
  text-align: center;
  color: #2b3674;
}
.wel_back {
  text-align: center;
  color: #2b3674;
  font-size: 40px;
}
.text {
  text-align: center;
  color: #2b3674;
}
.google_pic {
  text-align: center;
}
.sign_google {
  text-align: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #ededed;
  padding: 8px 20px;
  border-radius: 4px;
  display: flex;
  cursor: pointer;
  &:hover {
    box-shadow: 2px 2px 5px rgb(209, 209, 209);
  }
}
.sign_up {
  text-align: center;
  color: #2b3674;
}
.forget_pass {
  margin-top: -2rem;
  display: flex;
  justify-content: space-between;
}
</style>
